import { Button, useTheme } from '@mui/material';

export const SearchButton = ({ ...props }) => {
  const theme = useTheme();

  return (
    <Button
      {...props}
      sx={{
        width: '100%',
        height: '55px',
        bgcolor: theme.primary || '#000',
        color: theme.text1,
        fontSize: '16px',
        fontWeight: 600,
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
        '&:hover': {
          bgcolor: theme.primary || '#000',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
          color: theme.text1,
        },
      }}
    />
  );
};

export const containerSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%',
  flexDirection: { xs: 'column', sm: 'row' },
  marginTop: { xs: '14px', sm: 0 },
};

export const passengersButtonSx = {
  height: '100%',
  position: 'relative',
  width: { xs: '100%', md: 'fit-content' },
};

export const popoverSx = {
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  width: 'auto',
  minWidth: 200,
  zIndex: 1300,
  padding: '1rem',
  border: '1px solid #E5E5E5',
  overflowY: 'overlay',
  backgroundColor: '#fff',
  '&::-webkit-scrollbar': { display: 'none' }, // Chrome, Edge, Safari
  scrollbarWidth: 'none', // Firefox
  msOverflowStyle: 'none', // IE 10+
  overflow: 'visible',
};

export const searchButtonSx = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: '55px',
  marginTop: { xs: '14px', sm: 0 },
};
